/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { PriceRowUpdateDto } from './PriceRowUpdateDto';
import {
    PriceRowUpdateDtoFromJSON,
    PriceRowUpdateDtoFromJSONTyped,
    PriceRowUpdateDtoToJSON,
    PriceRowUpdateDtoToJSONTyped,
} from './PriceRowUpdateDto';

/**
 * 
 * @export
 * @interface SavePriceRowsRequestBody
 */
export interface SavePriceRowsRequestBody {
    /**
     * 
     * @type {Array<PriceRowUpdateDto>}
     * @memberof SavePriceRowsRequestBody
     */
    priceRows: Array<PriceRowUpdateDto>;
}

/**
 * Check if a given object implements the SavePriceRowsRequestBody interface.
 */
export function instanceOfSavePriceRowsRequestBody(value: object): value is SavePriceRowsRequestBody {
    if (!('priceRows' in value) || value['priceRows'] === undefined) return false;
    return true;
}

export function SavePriceRowsRequestBodyFromJSON(json: any): SavePriceRowsRequestBody {
    return SavePriceRowsRequestBodyFromJSONTyped(json, false);
}

export function SavePriceRowsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavePriceRowsRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'priceRows': ((json['priceRows'] as Array<any>).map(PriceRowUpdateDtoFromJSON)),
    };
}

export function SavePriceRowsRequestBodyToJSON(json: any): SavePriceRowsRequestBody {
    return SavePriceRowsRequestBodyToJSONTyped(json, false);
}

export function SavePriceRowsRequestBodyToJSONTyped(value?: SavePriceRowsRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceRows': ((value['priceRows'] as Array<any>).map(PriceRowUpdateDtoToJSON)),
    };
}

